import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative overflow-hidden">
        <div className="aspect-[3/4] w-full overflow-hidden">
          <img
            src={manga.cover}
            alt={`${manga.title} 漫画封面`}
            title={`${manga.title} ${manga.category}`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          {manga.status}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-background-950/70 px-2 py-0.5 text-xs font-semibold text-background-50 backdrop-blur-sm">
          <i className="ri-star-fill mr-0.5 text-accent-400" />
          {manga.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="font-display text-base font-bold text-foreground-900 md:text-lg">
          {manga.title}
        </h3>
        <div className="flex flex-wrap gap-1.5">
          {manga.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {manga.description}
        </p>
        <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-2.5 text-xs text-foreground-500">
          <span className="whitespace-nowrap">已更 {manga.chapters} 话</span>
          <span className="flex items-center gap-1 whitespace-nowrap text-foreground-600">
            <i className="ri-eye-line" />
            {manga.views}
          </span>
        </div>
      </div>
    </article>
  );
}